<template>
	<div>
		<router-link :to="{name: 'news'}">
			<span class="fa fa-long-arrow-alt-left" />
			Return to news
		</router-link>

		<img :src="news.image" class="mt-2 mb-4 img-fluid">

		<h1 class="mt-1 mb-1">{{ news.title }}</h1>
		
		<div v-html="news.content" />
	</div>
</template>

<script>
	import store from '../../../store';
	import {mapGetters} from 'vuex';

	export default {
		computed: {
			...mapGetters({
				getNewsById: 'news/getById',
			}),

			news() {
				return this.getNewsById(parseInt(this.$route.params.id));
			},
		},

		async beforeRouteEnter(to, from, next) {
			await store.dispatch('news/fetch', {
				newsId: parseInt(to.params.id),
			});
			next();
		},

		meta: {
			title: 'View a news entry',

			meta: [
				{property: 'og:title', content: 'View a news entry / Al-Shayah'},
			],
		},
	};
</script>

<style scoped>
	img {
		width: 100%;
		object-fit: cover;
		height: 480px;
	}
</style>
